module.exports = __webpack_public_path__ + "static/img/banner_freeCpr.3e8f051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_freeCpr.jpg
// module id = 8jg4
// module chunks = 1